// Intercom initialization following official documentation
// https://developers.intercom.com/installing-intercom/docs/intercom-javascript

import { getIntercomAppId } from '../utils/intercom';

// Initialize Intercom
const initializeIntercom = (): void => {
  if (typeof window === 'undefined' || !window.PT_ENV) {
    return;
  }

  const appId = getIntercomAppId();

  // Set up Intercom settings
  window.intercomSettings = {
    app_id: appId,
  };

  // Check if Intercom is already loaded
  if (typeof window.Intercom === 'function') {
    // do nothing
  } else {
    // Intercom is not loaded, set up the queue and load the script
    const intercom = (...args: any[]) => intercom.c(args);
    intercom.q = [] as any[];
    intercom.c = (args: any[]) => intercom.q.push(args);
    window.Intercom = intercom;

    // Load the Intercom script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://widget.intercom.io/widget/${appId}`;

    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    }
  }
};

// Initialize Intercom when this module is loaded
initializeIntercom();
